import { render, staticRenderFns } from "./serviceMerchantEdit.vue?vue&type=template&id=2b99b3f9&scoped=true"
import script from "./serviceMerchantEdit.vue?vue&type=script&lang=js"
export * from "./serviceMerchantEdit.vue?vue&type=script&lang=js"
import style0 from "./serviceMerchantEdit.vue?vue&type=style&index=0&id=2b99b3f9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b99b3f9",
  null
  
)

export default component.exports